module.exports = __webpack_public_path__ + "4b75adc57c6c0d2d56fe8a0ed4d69672.png";